import { Locale } from 'chaika-enums';
export const organizationModule = {
    scheduleSettins: {
        [Locale.Ru]: `Настройка смен расписания`,
        [Locale.Am]: `Ժամանակացույցի հերթափոխերի կարգավորում`,
        [Locale.En]: `Setting up schedule shifts`,
        [Locale.Pt]: 'Configurando turnos de horário',
        [Locale.Ge]: `Setting up schedule shifts`,
    },
    paidCancelTimeText: {
        [Locale.Ru]: `Время для платной отмены по умолчания`,
        [Locale.Am]: `Վճարովի չեղարկման լռելյայն ժամանակ`,
        [Locale.En]: `Paid cancellation time by default`,
        [Locale.Pt]: 'Tempo de cancelamento pago por padrão',
        [Locale.Ge]: `Paid cancellation time by default`,
    },
    printLogoLink: {
        [Locale.Ru]: `Ссылка на логотип печати`,
        [Locale.Am]: `Տպագրական լոգոյի հղում`,
        [Locale.En]: `Print Logo Link`,
        [Locale.Pt]: 'Imprimir link do logotipo',
        [Locale.Ge]: `Print Logo Link`,
    },
    listOfAccountants: {
        [Locale.Ru]: `Список бухгалтеров`,
        [Locale.Am]: `Հաշվապահների ցանկ`,
        [Locale.En]: `List of accountants`,
        [Locale.Pt]: 'Lista de contadores',
        [Locale.Ge]: `List of accountants`,
    },
    closeBillingPeriodAfter: {
        [Locale.Ru]: `Дней до закрытия расчетного периода`,
        [Locale.Am]: `Օրեր մինչև հաշվարկային ժամանակահատվածի փակումը`,
        [Locale.En]: `Days to billing period closing`,
        [Locale.Pt]: 'Dias para o fechamento do período de faturamento',
        [Locale.Ge]: `Days to billing period closing`,
    },
    mainContract: {
        [Locale.Ru]: `Основной договор`,
        [Locale.Am]: `Հիմնական պայմանագիր`,
        [Locale.En]: `Main contract`,
        [Locale.Pt]: 'Contrato principal',
        [Locale.Ge]: `Main contract`,
    },
    aliasForAttachments: {
        [Locale.Ru]: `Алиас для прикреплений`,
        [Locale.Am]: `Կցումների ալիաս`,
        [Locale.En]: `Alias for attachments`,
        [Locale.Pt]: 'Alias ​​para anexos',
        [Locale.Ge]: `Alias for attachments`,
    },
    legalEntitySettings: {
        [Locale.Ru]: `Настройки юридического лица`,
        [Locale.Am]: `Իրավաբանական անձի կարգավորումներ`,
        [Locale.En]: `Legal entity settings`,
        [Locale.Pt]: 'Configurações de entidade legal',
        [Locale.Ge]: `Legal entity settings`,
    },
    kpp: {
        [Locale.Ru]: `КПП`,
        [Locale.Am]: `ԿՊՊ`,
        [Locale.En]: `KPP`,
        [Locale.Pt]: 'KPP',
        [Locale.Ge]: `KPP`,
    },
    OGRN: {
        [Locale.Ru]: `ОГРН`,
        [Locale.Am]: `ՕԳՌՆ`,
        [Locale.En]: `OGRN`,
        [Locale.Pt]: 'PSRN',
        [Locale.Ge]: `OGRN`,
    },
    bank: {
        [Locale.Ru]: `Банк`,
        [Locale.Am]: `Բանկ`,
        [Locale.En]: `Bank`,
        [Locale.Pt]: 'banco',
        [Locale.Ge]: `Bank`,
    },
    BIC: {
        [Locale.Ru]: `БИК`,
        [Locale.Am]: `ԲԻԿ`,
        [Locale.En]: `BIC`,
        [Locale.Pt]: 'BIC',
        [Locale.Ge]: `BIC`,
    },
    OKPO: {
        [Locale.Ru]: `ОКПО`,
        [Locale.Am]: `ՕԿՊՕ`,
        [Locale.En]: `OKPO`,
        [Locale.Pt]: 'GRANDE',
        [Locale.Ge]: `OKPO`,
    },
    currentAccount: {
        [Locale.Ru]: `Расчетный счет`,
        [Locale.Am]: `Հաշվարկային հաշիվ`,
        [Locale.En]: `Current account`,
        [Locale.Pt]: 'Conta corrente',
        [Locale.Ge]: `Current account`,
    },
    corAccount: {
        [Locale.Ru]: `Кор счет`,
        [Locale.Am]: `Թղթակցային հաշիվ`,
        [Locale.En]: `Cor account`,
        [Locale.Pt]: 'Conta cor',
        [Locale.Ge]: `Cor account`,
    },
    mailForBills: {
        [Locale.Ru]: `Почта для счетов`,
        [Locale.Am]: `Էլ. փոստ հաշիվների համար`,
        [Locale.En]: `Mail for bills`,
        [Locale.Pt]: 'Correio para contas',
        [Locale.Ge]: `Mail for bills`,
    },
    mailForApprovals: {
        [Locale.Ru]: `Почта для согласований`,
        [Locale.Am]: `Էլ. փոստ համաձայնեցումների համար`,
        [Locale.En]: `Mail for approvals`,
        [Locale.Pt]: 'Correio para aprovações',
        [Locale.Ge]: `Mail for approvals`,
    },
    mailForDocumentation: {
        [Locale.Ru]: `Почта для документации`,
        [Locale.Am]: `Էլ. փոստ փաստաթղթերի համար`,
        [Locale.En]: `Mail for documentation`,
        [Locale.Pt]: 'Correio para documentação',
        [Locale.Ge]: `Mail for documentation`,
    },
    mailForConclusions: {
        [Locale.Ru]: `Почта для заключений`,
        [Locale.Am]: `Էլ. փոստ եզրակացությունների համար`,
        [Locale.En]: `Mail for conclusions`,
        [Locale.Pt]: 'Correio para conclusões',
        [Locale.Ge]: `Mail for conclusions`,
    },
    otherMail: {
        [Locale.Ru]: `Другая почта`,
        [Locale.Am]: `Այլ էլ. փոստ`,
        [Locale.En]: `Other mail`,
        [Locale.Pt]: 'Outros e-mails',
        [Locale.Ge]: `Other mail`,
    },
    customizedReports: {
        [Locale.Ru]: `Индивидуальные отчеты`,
        [Locale.Am]: `Անհատական հաշվետվություններ`,
        [Locale.En]: `Customized reports`,
        [Locale.Pt]: 'Relatórios personalizados',
        [Locale.Ge]: `Customized reports`,
    },
    attachmentStartDate: {
        [Locale.Ru]: `Дата начала прикрепления`,
        [Locale.Am]: `Կցման սկզբի ամսաթիվ`,
        [Locale.En]: `Date of attachment start`,
        [Locale.Pt]: 'Data de início do anexo',
        [Locale.Ge]: `Date of attachment start`,
    },
    attachmentEndDate: {
        [Locale.Ru]: `Дата конца прикрепления`,
        [Locale.Am]: `Կցման ավարտի ամսաթիվ`,
        [Locale.En]: `Date of attachment end`,
        [Locale.Pt]: 'Data de término do anexo',
        [Locale.Ge]: `Date of attachment end`,
    },
    relationshipLEOText: {
        [Locale.Ru]: `Связь организации с юридическим лицом`,
        [Locale.Am]: `Կազմակերպության կապն իրավաբանական անձի հետ`,
        [Locale.En]: `Relationship between an organization and a legal entity`,
        [Locale.Pt]: 'Relacionamento entre uma organização e uma pessoa jurídica',
        [Locale.Ge]: `Relationship between an organization and a legal entity`,
    },
    clinicNetworkSettings: {
        [Locale.Ru]: `Настройки сетей клиник`,
        [Locale.Am]: `Կլինիկաների ցանցերի կարգավորումներ`,
        [Locale.En]: `Clinic network settings`,
        [Locale.Pt]: 'Configurações de rede da clínica',
        [Locale.Ge]: `Clinic network settings`,
    },
    deviceScheduleSettings: {
        [Locale.Ru]: `Настройки расписания приборов`,
        [Locale.Am]: `Սարքերի ժամանակացույցի կարգավորումներ`,
        [Locale.En]: `Device schedule settings`,
        [Locale.Pt]: 'Configurações de programação do dispositivo',
        [Locale.Ge]: `Device schedule settings`,
    },
    organizationSettings: {
        [Locale.Ru]: `Настройки организаций`,
        [Locale.Am]: `Կազմակերպությունների կարգավորումներ`,
        [Locale.En]: `Organization settings`,
        [Locale.Pt]: 'Configurações da organização',
        [Locale.Ge]: `Organization settings`,
    },
    translationOfTitle: {
        [Locale.Ru]: `Перевод названия`,
        [Locale.Am]: `Անվանման թարգմանություն`,
        [Locale.En]: `Translation of the title`,
        [Locale.Pt]: 'Tradução do título',
        [Locale.Ge]: `Translation of the title`,
    },
    chiefPhysician: {
        [Locale.Ru]: `Главный врач`,
        [Locale.Am]: `Գլխավոր բժիշկ`,
        [Locale.En]: `Chief physician`,
        [Locale.Pt]: 'Médico-chefe',
        [Locale.Ge]: `Chief physician`,
    },
    requiresEdsForEntries: {
        [Locale.Ru]: `Необходима ЭЦП для записей`,
        [Locale.Am]: `Գրառումների համար պահանջվում է էլեկտրոնային ստորագրություն`,
        [Locale.En]: `Electronic signature required for entries`,
        [Locale.Pt]: 'Assinatura eletrônica obrigatória para registros',
        [Locale.Ge]: `ჩანაწერებისთვის საჭიროა ელექტრონული ხელმოწერა`,
    },
    techNameText: {
        [Locale.Ru]: `Техническое название для Как добраться`,
        [Locale.Am]: `Տեխնիկական անվանում «Ինչպես հասնել»-ի համար`,
        [Locale.En]: `Technical name for How to get there`,
        [Locale.Pt]: 'Nome técnico de Como chegar',
        [Locale.Ge]: `Technical name for How to get there`,
    },
    seal: {
        [Locale.Ru]: `Печать`,
        [Locale.Am]: `Կնիք`,
        [Locale.En]: `Seal`,
        [Locale.Pt]: 'Aldeia',
        [Locale.Ge]: `Seal`,
    },
    backupSeal: {
        [Locale.Ru]: `Резервная печать`,
        [Locale.Am]: `Պահուստային կնիք`,
        [Locale.En]: `Backup seal`,
        [Locale.Pt]: 'Selo de reserva',
        [Locale.Ge]: `Backup seal`,
    },
    signatureOfCP: {
        [Locale.Ru]: `Подпись главного врача`,
        [Locale.Am]: `Գլխավոր բժշկի ստորագրություն`,
        [Locale.En]: `Signature of the Chief Physician`,
        [Locale.Pt]: 'Assinatura do Médico Chefe',
        [Locale.Ge]: `Signature of the Chief Physician`,
    },
    backupSignatureOfCP: {
        [Locale.Ru]: `Резервная подпись главного врача`,
        [Locale.Am]: `Գլխավոր բժշկի պահուստային ստորագրություն`,
        [Locale.En]: `Backup signature of the Chief Physician`,
        [Locale.Pt]: 'Assinatura de backup do Médico Chefe',
        [Locale.Ge]: `Backup signature of the Chief Physician`,
    },
    officeScheduleSettings: {
        [Locale.Ru]: `Настройки расписания кабинетов`,
        [Locale.Am]: `Կաբինետների ժամանակացույցի կարգավորումներ`,
        [Locale.En]: `Office schedule settings`,
        [Locale.Pt]: 'Configurações de agendamento do escritório',
        [Locale.Ge]: `Office schedule settings`,
    },
    organizationWTSettings: {
        [Locale.Ru]: `Настройки рабочего времени организации`,
        [Locale.Am]: `Կազմակերպության աշխատանքային ժամերի կարգավորումներ`,
        [Locale.En]: `Organization working hours settings`,
        [Locale.Pt]: 'Configurações de horário de trabalho da organização',
        [Locale.Ge]: `Organization working hours settings`,
    },
    localTime: {
        [Locale.Ru]: `Локальное время`,
        [Locale.Am]: `Տեղական ժամանակ`,
        [Locale.En]: `Lacal time`,
        [Locale.Pt]: 'Hora local',
        [Locale.Ge]: `Lacal time`,
    },
    charity: {
        [Locale.Ru]: `Благотворительный фонд`,
        [Locale.Am]: `Բարեգործական հիմնադրամ`,
        [Locale.En]: `Charity`,
        [Locale.Pt]: 'Caridade',
        [Locale.Ge]: `Charity`,
    },
    assistance: {
        [Locale.Ru]: `Ассистанс`,
        [Locale.Am]: `Ասիստանս`,
        [Locale.En]: `Assistance`,
        [Locale.Pt]: 'Assistência',
        [Locale.Ge]: `Assistance`,
    },
    externalClinic: {
        [Locale.Ru]: `Внешняя клиника`,
        [Locale.Am]: `Արտաքին կլինիկա`,
        [Locale.En]: `External Clinic`,
        [Locale.Pt]: 'Clínica Externa',
        [Locale.Ge]: `External Clinic`,
    },
    toLegalEntities: {
        [Locale.Ru]: `К юридическим лицам`,
        [Locale.Am]: `Դեպի իրավաբանական անձինք`,
        [Locale.En]: `To legal entities`,
        [Locale.Pt]: 'Para pessoas jurídicas',
        [Locale.Ge]: `To legal entities`,
    },
    contractMustBeText: {
        [Locale.Ru]: `Номер договора должен быть больше или равен трём символам`,
        [Locale.Am]: `Պայմանագրի համարը պետք է լինի առնվազն երեք նիշ`,
        [Locale.En]: `The contract number must be greater than or equal to three characters.`,
        [Locale.Pt]: 'O número do contrato deve ser maior ou igual a três caracteres.',
        [Locale.Ge]: `The contract number must be greater than or equal to three characters.`,
    },
    abbreviation: {
        [Locale.Ru]: `Абревиатура`,
        [Locale.Am]: `Հապավում`,
        [Locale.En]: `Abbreviation`,
        [Locale.Pt]: 'Abreviação',
        [Locale.Ge]: `Abbreviation`,
    },
    createCustomReport: {
        [Locale.Ru]: `Создание индивидуального отчета`,
        [Locale.Am]: `Անհատական հաշվետվության ստեղծում`,
        [Locale.En]: `Create a custom report`,
        [Locale.Pt]: 'Crie um relatório personalizado',
        [Locale.Ge]: `Create a custom report`,
    },
    createIndividualPrice: {
        [Locale.Ru]: `Создание индивидуальной цены`,
        [Locale.Am]: `Անհատական գնի ստեղծում`,
        [Locale.En]: `Create individual price`,
        [Locale.Pt]: 'Criar preço individual',
        [Locale.Ge]: `Create individual price`,
    },
    createReference: {
        [Locale.Ru]: `Создание референса`,
        [Locale.Am]: `Ռեֆերենսի ստեղծում`,
        [Locale.En]: `Create reference`,
        [Locale.Pt]: 'Criar referência',
        [Locale.Ge]: `Create reference`,
    },
    editReference: {
        [Locale.Ru]: `Редактирование референса`,
        [Locale.Am]: `Ռեֆերենսի խմբագրում`,
        [Locale.En]: `Edit reference`,
        [Locale.Pt]: 'Editar referência',
        [Locale.Ge]: `Edit reference`,
    },
    createReferenceTable: {
        [Locale.Ru]: `Создание таблицы референсов`,
        [Locale.Am]: `Ռեֆերենսների աղյուսակի ստեղծում`,
        [Locale.En]: `Create reference table`,
        [Locale.Pt]: 'Criar tabela de referência',
        [Locale.Ge]: `Create reference table`,
    },
    editReferenceTable: {
        [Locale.Ru]: `Редактирование таблицы референсов`,
        [Locale.Am]: `Ռեֆերենսների աղյուսակի խմբագրում`,
        [Locale.En]: `Edit reference table`,
        [Locale.Pt]: 'Editar tabela de referência',
        [Locale.Ge]: `Edit reference table`,
    },
    changeCustomReport: {
        [Locale.Ru]: `Изменение индивидуального отчета`,
        [Locale.Am]: `Անհատական հաշվետվության փոփոխում`,
        [Locale.En]: `Changing an individual report`,
        [Locale.Pt]: 'Alterando um relatório individual',
        [Locale.Ge]: `Changing an individual report`,
    },
    onnCreateCustomReportText: {
        [Locale.Ru]: `При создании отчета можно (но не обязательно) загрузить файл шаблона. Если шаблон не загружен при создании, его можно будет добавить позже. Если шаблон не загружен, отчетом нельзя будет воспользоваться.`,
        [Locale.Am]: `Հաշվետվություն ստեղծելիս կարելի է (բայց պարտադիր չէ) վերբեռնել ձևանմուշի ֆայլը։ Եթե ձևանմուշը չի վերբեռնվել ստեղծելիս, այն կարելի է ավելացնել ավելի ուշ։ Եթե ձևանմուշը վերբեռնված չէ, հաշվետվությունից հնարավոր չի լինի օգտվել։`,
        [Locale.En]: `When creating a report, you can (but are not required to) load a template file. If the template is not loaded when created, it can be added later. If the template is not loaded, the report cannot be used.`,
        [Locale.Pt]: 'Ao criar um relatório, você pode (mas não é obrigado a) carregar um arquivo de modelo. Se o modelo não for carregado quando criado, ele poderá ser adicionado posteriormente. Se o modelo não estiver carregado, o relatório não poderá ser usado.',
        [Locale.Ge]: `When creating a report, you can (but are not required to) load a template file. If the template is not loaded when created, it can be added later. If the template is not loaded, the report cannot be used.`,
    },
    onAddCustomReportText: {
        [Locale.Ru]: `Добавление или удаление файлов происходит без сохранения.`,
        [Locale.Am]: `Ֆայլերի ավելացումը կամ ջնջումը տեղի է ունենում առանց պահպանման։`,
        [Locale.En]: `Adding or deleting files occurs without saving.`,
        [Locale.Pt]: 'A adição ou exclusão de arquivos ocorre sem salvá-los.',
        [Locale.Ge]: `Adding or deleting files occurs without saving.`,
    },
    toOrganizations: {
        [Locale.Ru]: `К организациям`,
        [Locale.Am]: `Դեպի կազմակերպություններ`,
        [Locale.En]: `To organizations`,
        [Locale.Pt]: 'Para organizações',
        [Locale.Ge]: `To organizations`,
    },
    toOrganization: {
        [Locale.Ru]: `К организации`,
        [Locale.Am]: `Դեպի կազմակերպություն`,
        [Locale.En]: `To organization`,
        [Locale.Pt]: 'Para organização',
        [Locale.Ge]: `To organization`,
    },
    inventoryNumber: {
        [Locale.Ru]: `Инвентарный номер`,
        [Locale.Am]: `Գույքագրման համար`,
        [Locale.En]: `Inventory number`,
        [Locale.Pt]: 'Número de inventário',
        [Locale.Ge]: `Inventory number`,
    },
    floor: {
        [Locale.Ru]: `Этаж`,
        [Locale.Am]: `Հարկ`,
        [Locale.En]: `Floor`,
        [Locale.Pt]: 'Chão',
        [Locale.Ge]: `Floor`,
    },
    offerFor: {
        [Locale.Ru]: `Предлагать для`,
        [Locale.Am]: `Առաջարկել՝`,
        [Locale.En]: `Offer for`,
        [Locale.Pt]: 'Oferta para',
        [Locale.Ge]: `Offer for`,
    },
    overlapsScheduleText: {
        [Locale.Ru]: `Есть пересечени с бронями расписания на даты:`,
        [Locale.Am]: `Կան հատումներ ժամանակացույցի ամրագրումների հետ հետևյալ ամսաթվերին՝`,
        [Locale.En]: `There are overlaps with the schedule bookings for the dates:`,
        [Locale.Pt]: 'Existem sobreposições com as reservas de programação para as datas:',
        [Locale.Ge]: `There are overlaps with the schedule bookings for the dates:`,
    },
    buildSchedule: {
        [Locale.Ru]: `Построить расписание`,
        [Locale.Am]: `Կառուցել ժամանակացույց`,
        [Locale.En]: `Build a schedule`,
        [Locale.Pt]: 'Crie um cronograma',
        [Locale.Ge]: `Build a schedule`,
    },
    saveSchedule: {
        [Locale.Ru]: `Сохранить расписание`,
        [Locale.Am]: `Պահպանել ժամանակացույցը`,
        [Locale.En]: `Save schedule`,
        [Locale.Pt]: 'Salvar programação',
        [Locale.Ge]: `Save schedule`,
    },
    cancelSeating: {
        [Locale.Ru]: `Отменить рассадку`,
        [Locale.Am]: `Չեղարկել տեղաբաշխումը`,
        [Locale.En]: `Cancel seating`,
        [Locale.Pt]: 'Cancelar assento',
        [Locale.Ge]: `Cancel seating`,
    },
    hasConflicts: {
        [Locale.Ru]: `Имеются конфликты`,
        [Locale.Am]: `Առկա են կոնֆլիկտներ`,
        [Locale.En]: `There are conflicts`,
        [Locale.Pt]: 'Existem conflitos',
        [Locale.Ge]: `There are conflicts`,
    },
    shceduleConfiltText: {
        [Locale.Ru]: `В результате  сохранения будут изменены текущие активные рабочие времена у врачей:`,
        [Locale.Am]: `Պահպանման արդյունքում կփոփոխվեն բժիշկների ընթացիկ ակտիվ աշխատանքային ժամերը՝`,
        [Locale.En]: `As a result of the retention, the current active working hours of doctors will be changed:`,
        [Locale.Pt]: 'Em decorrência da retenção, o atual horário ativo de trabalho dos médicos será alterado:',
        [Locale.Ge]: `As a result of the retention, the current active working hours of doctors will be changed:`,
    },
    checkedAndSave: {
        [Locale.Ru]: `Все проверено. Сохранить.`,
        [Locale.Am]: `Ամեն ինչ ստուգված է։ Պահպանել։`,
        [Locale.En]: `Everything is checked. Save.`,
        [Locale.Pt]: 'Tudo está verificado. Salvar.',
        [Locale.Ge]: `Everything is checked. Save.`,
    },
    erroOnWTsaveText: {
        [Locale.Ru]: `Возникла ошибка при сохранении. Пересекаются рабочие времена`,
        [Locale.Am]: `Պահպանելիս առաջացել է սխալ։ Աշխատանքային ժամերը հատվում են`,
        [Locale.En]: `There was an error saving. Working times overlap`,
        [Locale.Pt]: 'Ocorreu um erro ao salvar. Os horários de trabalho se sobrepõem',
        [Locale.Ge]: `There was an error saving. Working times overlap`,
    },
    frmo: {
        [Locale.Ru]: `ФРМО`,
        [Locale.Am]: `FRMO`,
        [Locale.En]: `FRMO`,
        [Locale.Pt]: 'FRMO',
        [Locale.Ge]: `FRMO`,
    },
    oid: {
        [Locale.Ru]: `OID`,
        [Locale.Am]: `OID`,
        [Locale.En]: `OID`,
        [Locale.Pt]: 'OID',
        [Locale.Ge]: `OID`,
    },
    regionCode: {
        [Locale.Ru]: `Код региона`,
        [Locale.Am]: `Տարածաշրջանի կոդ`,
        [Locale.En]: `Region code`,
        [Locale.Pt]: 'Código da região',
        [Locale.Ge]: `Region code`,
    },
    invalidFrmoOid: {
        [Locale.Ru]: `Нужно 11 чисел через точку`,
        [Locale.Am]: `Անհրաժեշտ է 11 թիվ՝ կետերով`,
        [Locale.En]: `Must be 11 dot-separated numbers`,
        [Locale.Pt]: 'Deve ter 11 números separados por ponto',
        [Locale.Ge]: `Must be 11 dot-separated numbers`,
    },
    lpuUid: {
        [Locale.Ru]: `ID филиала в МедФлексе (lpu_uid)`,
        [Locale.Am]: `Մասնաճյուղի ID MedFlex-ում (lpu_uid)`,
        [Locale.En]: `MedFlex branch ID (lpu_uid)`,
        [Locale.Pt]: 'ID da filial no MedFlex (lpu_uid)',
        [Locale.Ge]: `MedFlex branch ID (lpu_uid)`,
    },
    invalidLpuUid: {
        [Locale.Ru]: `Нужен UUID`,
        [Locale.Am]: `Անհրաժեշտ է UUID`,
        [Locale.En]: `Must be a UUID`,
        [Locale.Pt]: 'Deve ser um UUID',
        [Locale.Ge]: `Must be a UUID`,
    },
    departmentOid: {
        [Locale.Ru]: `OID подразделения (ФРМО)`,
        [Locale.Am]: `Ստորաբաժանման OID (FRMO)`,
        [Locale.En]: `Department OID (FRMO)`,
        [Locale.Pt]: 'OID do departamento (FRMO)',
        [Locale.Ge]: `Department OID (FRMO)`,
    },
    invalidDepartmentOid: {
        [Locale.Ru]: `Нужно не меньше 12 чисел через точку`,
        [Locale.Am]: `Անհրաժեշտ է առնվազն 12 թիվ՝ կետերով`,
        [Locale.En]: `Must be at least 12 dot-separated numbers`,
        [Locale.Pt]: 'Deve ter pelo menos 12 números separados por ponto',
        [Locale.Ge]: `Must be at least 12 dot-separated numbers`,
    },
    departmentName: {
        [Locale.Ru]: `Наименование подразделения (ФРМО)`,
        [Locale.Am]: `Ստորաբաժանման անվանում (FRMO)`,
        [Locale.En]: `Department name (FRMO)`,
        [Locale.Pt]: 'Nome do departamento (FRMO)',
        [Locale.Ge]: `Department name (FRMO)`,
    },
    enterDepartmentName: {
        [Locale.Ru]: `Например: Амбулаторное отделение`,
        [Locale.Am]: `Օրինակ՝ Амбулаторное отделение`,
        [Locale.En]: `E.g. Амбулаторное отделение`,
        [Locale.Pt]: 'Ex. Амбулаторное отделение',
        [Locale.Ge]: `E.g. Амбулаторное отделение`,
    },
    invalidRegionCode: {
        [Locale.Ru]: `Выберите регион`,
        [Locale.Am]: `Ընտրեք տարածաշրջանը`,
        [Locale.En]: `Select a region`,
        [Locale.Pt]: 'Selecione a região',
        [Locale.Ge]: `Select a region`,
    },
    enterAddress: {
        [Locale.Ru]: `Например: г Москва, ул Ладожская, д 4-6 стр 1`,
        [Locale.Am]: `Օրինակ՝ г Москва, ул Ладожская, д 4-6 стр 1`,
        [Locale.En]: `E.g. г Москва, ул Ладожская, д 4-6 стр 1`,
        [Locale.Pt]: 'Ex. г Москва, ул Ладожская, д 4-6 стр 1',
        [Locale.Ge]: `E.g. г Москва, ул Ладожская, д 4-6 стр 1`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
